module.exports = __webpack_public_path__ + "img/approved-good-cause-01.26105703.jpg";